
export const HOME_PAGE = "Landing-page";
export const img = "orasi/admin/resources/orasiv1/images/";
export const compress = "auto=compress,format";
export const appname = "orasidev";
export const imgmiddle = "orasi/admin/resources/orasiv1/images/";
export const imgcommon = "/orasi/common/images/";

